@if (content) {
    <div class="tooltip-content">{{ content }}</div>
}
